<template>
	<div v-if="page.slug === '404'">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
			:title="page.title || page.header"
		/>
		<main-heading
			v-else
			:title="page.title || page.header"
			:content="page.introductionContent"
			:graphic="{
				image: page.introductionGraphic,
				imageWebp: page.introductionGraphicWebp,
				alt: page.introductionGraphicAlt,
			}"
		/>

		<main-content
			class="content-wide"
			:class="page && page.headingImage ? '' : 'no-slider'"
			:content="page.content"
		/>
	</div>
	<div v-else>
		<slot />
	</div>
</template>

<script setup>
defineProps({
	page: { type: Object, default: () => {} },
	locale: { type: Object, default: () => {} },
});
</script>
